import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames'
import StudentStepsNew from './StudentStepsNew';

const StudentSteps = ({
  active,
  tempEnableReviewButton = false,
  isAssignmentCompleted
}) => {
  let run = localStorage.getItem('run');
  if (isAssignmentCompleted) {
    return (
      <div className="student-steps">
        <Link
          to={`/rank/${run}/schedule`}
          className={classNames('btn', 'btn-ter', { active: active === 0})}
        >
          Manage schedule
        </Link>
        <Link
          to={`/rank/${run}/manage-waitlists`}
          className={classNames('btn', 'btn-ter', { active: active === 1 })}
          >
          Waitlists
        </Link>
        <Link
          to={`/rank/${run}/find-classes`}
          className={classNames('btn', 'btn-ter', { active: active === 2})}
        >
          Find classes
        </Link>
      </div>
    );
  }
  return <StudentStepsNew active={active} tempEnableReviewButton={tempEnableReviewButton} />
  // return (
  //   <div className="student-steps">
  //     <Link
  //       to={`/rank/${run}/start`}
  //       className={classNames('btn', 'btn-ter', { active: active === 0 })}
  //     >
  //       Get Started
  //     </Link>
  //     <i className="fa fa-long-arrow-right" />
  //     <Link
  //       to={`/rank/${run}/find`}
  //       className={classNames('btn', 'btn-ter', { active: active === 1, disable: !elicitation || disableFindClassesButton })}
  //       onClick={
  //         !elicitation || disableFindClassesButton
  //           ? function(e) {
  //               e.preventDefault();
  //             }
  //           : null
  //       }
  //     >
  //       Find Classes
  //     </Link>
  //     <i className="fa fa-long-arrow-right" />
  //     <Link
  //       to={`/rank/${run}/rank`}
  //       className={classNames('btn', 'btn-ter', { active: active === 2, disable: !elicitation || disableRankClassesButton })}
  //       onClick={
  //         !elicitation || disableRankClassesButton
  //           ? function(e) {
  //               e.preventDefault();
  //             }
  //           : null
  //       }
  //     >
  //       Rank Classes
  //     </Link>
  //     <i className="fa fa-long-arrow-right" />
  //     <Link
  //       to={`/rank/${run}/schedules`}
  //       className={classNames('btn', 'btn-ter', { active: active === 3, disable: !elicitation || disableReviewSchedulesButton })}
  //       onClick={
  //         !elicitation || disableReviewSchedulesButton
  //           ? function(e) {
  //               e.preventDefault();
  //             }
  //           : null
  //       }
  //     >
  //       Review Schedules
  //     </Link>
  //     <i className="fa fa-long-arrow-right" />
  //     <Link
  //       to={`/rank/${run}/confirm`}
  //       className={classNames('btn', 'btn-ter', { active: active === 4, disable: !elicitation || disableConfirmButton })}
  //       onClick={
  //         !elicitation || disableConfirmButton
  //          ? (e) => e.preventDefault() : null
  //       }
  //     >
  //       Confirm
  //     </Link>
  //   </div>
  // );
};

StudentSteps.propTypes = {
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disableFindClassesButton: PropTypes.bool,
  disableRankClassesButton: PropTypes.bool,
  disableReviewSchedulesButton: PropTypes.bool,
  disableConfirmButton: PropTypes.bool
};

export default StudentSteps;



// WEBPACK FOOTER //
// ./src/components/common/StudentSteps.js